import { HttpClient } from '../httpClient';
import ContactResponse from '../responses/contactResponse';
import { BaseResponse } from '../responses/baseResponse';
import ContactRequest from '../requests/contactRequest';

const httpClient = new HttpClient();

export const getContact = async (ContactId: number) => {
  return httpClient.get<ContactResponse>({
    url: `/v1/Contacts/${ContactId}`,
    requiresToken: true,
  });
};

export const getContactsByDistrictId = async (DistrictId: number) => {
  return httpClient.get<ContactResponse>({
    url: `/v1/Contacts/ByDistrict/${DistrictId}`,
    requiresToken: true,
  });
};

export const createContact = async (Contactrequest: ContactRequest) => {
  return httpClient.post<ContactResponse>({
    url: '/v1/admin/Contacts',
    payload: Contactrequest,
    requiresToken: true,
  });
};

export const updateContact = async (
  ContactId: number,
  Contactrequest: ContactRequest
) => {
  return httpClient.put<BaseResponse>({
    url: `/v1/admin/Contacts/${ContactId}`,
    payload: Contactrequest,
    requiresToken: true,
  });
};

export const deleteContact = async (ContactId: number) => {
  return httpClient.delete<BaseResponse>({
    url: `/v1/admin/Contacts/${ContactId}`,
    requiresToken: true,
  });
};
